import React from 'react'
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import {withRouter} from 'react-router';
import CuentaSelected from "../../helpers/CuentaSelected";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import {MyFileBrowser} from "../../components/MyFileBrowser";

class GrandesClientes extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: null
        }
    };

    componentDidMount() {
        this.getFiles();
    }

    getFiles = async () => {
        const account = CuentaSelected.get();
        const response = await Api.get(`${Env.UrlBackend}/grandes-clientes/get-files/${account.cuentaCodigo}`);
        if (response.success) {
            this.setState({
                data: JSON.parse(response.data)
            })
        }
    }

    render() {
        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        }

                    ]}
                    actual='Grandes Clientes'
                />

                <h2>
                    <span>Grandes Clientes</span>
                </h2>

                <div style={{textAlign: 'center', paddingLeft: '30px', paddingRight: '30px'}}>

                    {
                        this.state.data ?
                            <MyFileBrowser
                                dataFiles={this.state.data}
                            />
                            : <p>Cargando...</p>
                    }


                </div>

            </div>
        );
    }
}

export default withRouter(GrandesClientes)